export const isMetamaskSupported = () => {
  return typeof window.ethereum !== "undefined";
};
